import React from 'react';

export default function Chrome({
  width = 88,
  height = 88,
}: {
  width?: number,
  height?: number,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 88 88"
    >
      <path
        fill="#EF3F36"
        d="M44.002 5.51s22.693-1.015 34.725 21.714H42.07s-6.918-.222-12.827 8.14c-1.698 3.51-3.523 7.126-1.475 14.251-2.95-4.98-15.66-27.032-15.66-27.032S21.074 6.408 44.001 5.51z"
      />
      <path
        fill="#FCD900"
        d="M77.549 63.21S67.077 83.307 41.317 82.313c3.183-5.487 18.333-31.63 18.333-31.63s3.66-5.857-.657-15.139c-2.197-3.224-4.435-6.596-11.65-8.394 5.804-.052 31.32 0 31.32 0s9.559 15.826-1.114 36.06z"
      />
      <path
        fill="#61BC5B"
        d="M10.613 63.368S-1.619 44.286 12.13 22.551c3.173 5.487 18.323 31.63 18.323 31.63s3.268 6.09 13.485 6.999c3.894-.285 7.946-.529 13.124-5.846-2.854 5.032-15.66 27.021-15.66 27.021s-18.546.338-30.789-18.987z"
      />
      <path
        fill="#5AB055"
        d="M41.307 82.504l5.156-21.44s5.665-.444 10.419-5.634c-2.95 5.17-15.575 27.074-15.575 27.074z"
      />
      <path
        fill="#fff"
        d="M26.73 44.245c0-9.451 7.692-17.116 17.176-17.116 9.485 0 17.177 7.665 17.177 17.116 0 9.45-7.692 17.115-17.177 17.115-9.484-.01-17.176-7.664-17.176-17.115z"
      />
      <path
        fill="url(#paint0_linear)"
        d="M29.605 44.243c0-7.865 6.398-14.25 14.302-14.25 7.894 0 14.302 6.375 14.302 14.25 0 7.866-6.397 14.251-14.302 14.251-7.893 0-14.301-6.385-14.301-14.25z"
      />
      <path
        fill="#EACA05"
        d="M78.652 27.16l-21.23 6.206s-3.204-4.684-10.089-6.206c5.973-.032 31.319 0 31.319 0z"
      />
      <path
        fill="#DF3A32"
        d="M27.355 48.833c-2.981-5.149-15.246-26.25-15.246-26.25l15.724 15.498s-1.613 3.31-1.008 8.045l.53 2.707z"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="43.907"
          x2="43.907"
          y1="30.194"
          y2="57.636"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#86BBE5" />
          <stop offset="1" stopColor="#1072BA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
